<template>
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{$t('message.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/Product' }">{{$t('message.vueProduct.productpage')}}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <div class="product">
        <el-form ref="productForm" :model="productForm" :inline="true" class="demo-form-inline">
            <el-form-item :label="$t('message.vueCompany.labIsDisabled')+' :'">
                <el-select size="mini" v-model="productForm.isDisabled" :placeholder="$t('message.pleaseSelect')" style="width:100px">
                    <el-option :label="$t('message.pleaseSelect')" value=""></el-option>
                    <el-option :label="$t('message.vueCompany.selIsDisabledYes')" value="true"></el-option>
                    <el-option :label="$t('message.vueCompany.selIsDisabledNo')" value="false"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('message.vueCategory.category')+' :'">
                <el-input v-model="productForm.input_category" size="mini"></el-input>
            </el-form-item>
            <el-form-item :label="$t('message.vueProduct.labProductCode')+' :'">
                <el-input v-model="productForm.input_productcode" size="mini"></el-input>
            </el-form-item>
            <el-form-item :label="$t('message.vueProduct.model_no')+' :'">
                <el-input v-model="productForm.input_modelno" size="mini"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="mini" class="btn_search"
                           @click="submitSearch" icon="el-icon-search">{{$t('message.vueCategory.button_search')}}</el-button>
            </el-form-item>
            <!--<el-row>
                <el-form-item>
                    <el-button size="mini" type="primary" class="btn_add"
                               @click="goAddProduct" icon="el-icon-circle-plus-outline">{{$t('message.vueProduct.button_add')}}</el-button>
                </el-form-item>
            </el-row>-->
        </el-form>
        <el-table :data="tableData" border size="mini">
            <el-table-column prop="ProductType" :label="$t('message.vueProduct.product_type')" width="150">
                <template #default="scope">
                    <span>{{scope.row.productType}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="ProductCode" :label="$t('message.vueProduct.product_code')" width="120">
                <template #default="scope">
                    <span>{{scope.row.productCode}}</span>
                </template>
            </el-table-column>

            <el-table-column prop="ItemCode" :label="$t('message.vueProduct.item_code')" width="120">
                <template #default="scope">
                    <span>{{scope.row.itemCode}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="Category" :label="$t('message.vueProduct.product_category')" width="170">
                <template #default="scope">
                    <span>{{scope.row.category}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="ProductName" :label="$t('message.vueProduct.product_name')" width="200">
                <template #default="scope">
                    <span>{{scope.row.productName}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="Currency" :label="$t('message.vueProduct.product_currency')" width="90">
                <template #default="scope">
                    <span>{{scope.row.currency}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="UnitPrice" :label="$t('message.vueProduct.unit_price')" width="100">
                <template #default="scope">
                    <span>{{scope.row.unitPrice}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="Price" :label="$t('message.vueProduct.price')" width="100">
                <template #default="scope">
                    <span>{{scope.row.price}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="Uom" :label="$t('message.vueProduct.uom')" width="70">
                <template #default="scope">
                    <span>{{scope.row.uom}}</span>
                </template>
            </el-table-column>
            
            <el-table-column :label="$t('message.operate')" min-width="195">
                <template #default="scope">
                    <el-button size="mini"
                               class="button_detail"
                               icon="el-icon-tickets"
                               @click="goDetail(scope.row)">{{$t('message.details')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-divider></el-divider>
        <el-pagination @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pageIndex"
                       :page-sizes="[10, 25, 50, 75, 100]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="count">
        </el-pagination>
    </div>
</template>

<style>
    .btn_search {
        color: #fff;
        background-color: green;
        font-weight: bolder;
    }
    .btn_add {
        font-weight: bolder;
    }
    .button_detail {
        font-weight: bolder;
    }
    .button_edit {
        color: #fff;
        background-color: orange;
        font-weight: bolder;
    }
</style>

<script>
    import AppStorage from '@/common/storage/app-storage'
    export default {
        name: 'Product',
        data() {
            return {
                tableData: null,
                language: AppStorage.getLanguage(),
                productForm: {
                    isDisabled: "false",
                    input_category: '',
                    input_productcode: '',
                    input_modelno: ''
                },
                pageIndex: 1,
                pageSize: 50,
                count: 0
            }
        },
        methods: {
            goAddProduct() {
                this.$router.push({ path: "/AddProduct" });
            },

            loadPage() {
                this.axios
                    .get('/api/Product/getproductpage', {
                        params: {
                            isDisabled: this.productForm.isDisabled,
                            Category: this.productForm.input_category,
                            ProductCode: this.productForm.input_productcode,
                            ModelNo: this.productForm.input_modelno,
                            pageIndex: this.pageIndex,
                            pageSize: this.pageSize
                        }
                    })
                    .then(response => {
                        var infos = response.data.data;
                        //var i = 0;
                        if (response.data.code == 1) {
                            infos = response.data.data;
                            this.tableData = infos.items;
                            this.count = infos.count;

                        } else {
                            this.tableData = null;
                            this.count = 0;
                        }
                    });
            },
            submitSearch() {
                this.pageIndex = 1;
                this.loadPage();
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.loadPage();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.loadPage();
            },
            goEdit(row) {
                this.$router.push({
                    path: "/EditProduct",
                    query: { ProductCode: row.productCode }
                });
            },
            goDetail(row) {
                this.$router.push({
                    path: "/ProductDetail",
                    query: { ProductCode: row.productCode }
                });
            },
            changeIsDisabled(row) {
                var isDisabled = false;
                if (row.isDisabled == false) {
                    isDisabled = true;
                }
                row.isLoading = true;
                return new Promise(resolve => {
                    this.axios
                        .post('/api/Product/disabledproduct', {
                            ProductCode: row.productCode,
                            IsDisabled: isDisabled,
                            UserNumber: AppStorage.getNumber(),
                        })
                        .then(response => {
                            row.isLoading = false;
                            if (response.data.code != 1) {
                                this.$message.error(this.$t('message.error'));
                                return resolve(false);
                            } else {
                                this.$message.success(this.$t('message.success'));
                                this.loadPage();
                                return resolve(true);
                            }
                        }).catch(error => {
                            console.log(error);
                            row.isLoading = false;
                            this.$message.error(this.$t('message.messageBox.connecterror'));
                            return resolve(false);
                        });
                })
            }
        },
        //这个组件内的方法，函数
        mounted() {
            this.loadPage();
        },
        watch: {
            $route() {
                //响应路由参数的变化
                this.submitSearch();
            }
        }
    };
</script>
